import { css, html, LitElement, PropertyValues } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { sharedStyles } from "../styles/shared";
import { property } from "lit/decorators/property.js";
import "./title";
import { Controller } from "../state/controller";
import { themeStore } from "../state/theme/theme-store";
import { COLOR_MODE_COLORS, Size } from "shared";
import { ASSETS_PATHS, DEFAULT_COLOR_MODE, ROUTES } from "../config";
import { pushState } from "../util/route-util";
import { Store } from "../state/store";

class LogoStore extends Store {
	model$ = {
		colorMode: themeStore.model$.colorMode
	};
}

@customElement("bs-logo")
export class BsLogo extends LitElement {
	@property({ type: String, reflect: true }) size: Size = "medium";
	@property({ type: Boolean, reflect: true }) dark = false;

	protected controller = new Controller(this, new LogoStore(), {
		colorMode: this.updateColorMode.bind(this)
	});

	static get styles() {
		return [
			sharedStyles,
			css`
				:host {
					display: inline-flex;
					align-items: center;
					gap: var(--space-s);
					user-select: none;
					cursor: pointer;
				}

				#logo {
					width: var(--logo-size, 30px);
					height: var(--logo-size, 30px);
				}

				:host([size="small"]) {
					--logo-size: 28px;
				}

				:host([size="large"]) {
					--logo-size: 40px;
				}

				:host([size="huge"]) {
					--logo-size: 60px;
				}

				#extension {
					color: var(--shade-dark);
					font-weight: normal;
				}

				#text {
					display: inline-flex;
				}
			`
		];
	}

	protected boundGoHome = this.goHome.bind(this);

	protected firstUpdated(props: PropertyValues) {
		super.firstUpdated(props);
		this.addEventListener("click", this.boundGoHome);
		this.updateColorMode();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		this.removeEventListener("click", this.boundGoHome);
	}

	updateColorMode() {
		this.dark = COLOR_MODE_COLORS[this.controller.model.colorMode ?? DEFAULT_COLOR_MODE]?.isDark ?? false;
	}

	goHome() {
		if (location.pathname === ROUTES.index) {
			window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
		} else {
			pushState(ROUTES.index);
		}
	}

	render() {
		const logoUrl = `${ASSETS_PATHS.brand}/logo/round/${this.dark ? "light" : "dark"}/logo.svg`;
		return html`
			<img id="logo" alt="Ideamap logo" src="${logoUrl}" />
			<slot>
				<bs-title id="text" size="${this.size}">
					<span>Ideamap</span>
					<span id="extension">.ai</span>
				</bs-title>
			</slot>
		`;
	}
}
